var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative c" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "pageFrom",
                      attrs: {
                        inline: "",
                        size: "small",
                        model: _vm.pageFrom,
                        rules: _vm.pageFromRules,
                        "label-position": "right",
                        "label-width": "120px",
                      },
                    },
                    [
                      !_vm.miniProgramCustomer
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "归属客户：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "请输入选择",
                                    clearable: "",
                                  },
                                  on: { change: _vm.search },
                                  model: {
                                    value: _vm.pageFrom.customerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageFrom, "customerId", $$v)
                                    },
                                    expression: "pageFrom.customerId",
                                  },
                                },
                                _vm._l(_vm.customers, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.miniProgramCustomer
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "发卡类型：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: "",
                                  },
                                  on: { change: _vm.search },
                                  model: {
                                    value: _vm.pageFrom.sendType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageFrom, "sendType", $$v)
                                    },
                                    expression: "pageFrom.sendType",
                                  },
                                },
                                _vm._l(_vm.sendTypeList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发放福卡：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.fudouCardId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "fudouCardId", $$v)
                                },
                                expression: "pageFrom.fudouCardId",
                              },
                            },
                            _vm._l(_vm.fuCardOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.cardName, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发放方式：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请选择", clearable: "" },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.customerEmpType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "customerEmpType", $$v)
                                },
                                expression: "pageFrom.customerEmpType",
                              },
                            },
                            _vm._l(
                              _vm.integralFormEnum,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "项目编号：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入项目编号",
                              clearable: "",
                            },
                            on: { change: _vm.search },
                            model: {
                              value: _vm.pageFrom.projectNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.pageFrom, "projectNumber", $$v)
                              },
                              expression: "pageFrom.projectNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isMinAdmin
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "申请编号：" } },
                            [
                              _c("el-input", {
                                staticClass: "selWidth",
                                attrs: {
                                  placeholder: "请输入申请编号",
                                  clearable: "",
                                },
                                on: { change: _vm.search },
                                model: {
                                  value: _vm.pageFrom.applicationNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageFrom,
                                      "applicationNumber",
                                      $$v
                                    )
                                  },
                                  expression: "pageFrom.applicationNumber",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isMinAdmin
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "审核状态：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "请选择审核状态",
                                    clearable: "",
                                  },
                                  on: { change: _vm.search },
                                  model: {
                                    value: _vm.pageFrom.auditStatus,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageFrom, "auditStatus", $$v)
                                    },
                                    expression: "pageFrom.auditStatus",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "待审核", value: 0 },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "通过", value: 1 },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "驳回", value: 2 },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "无需审核", value: 3 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发放时间：" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                            },
                            on: { change: _vm.handleExeTimeChange },
                            model: {
                              value: _vm.exeTimeRange,
                              callback: function ($$v) {
                                _vm.exeTimeRange = $$v
                              },
                              expression: "exeTimeRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isMinAdmin
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "审核时间：" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetimerange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始时间",
                                  "end-placeholder": "结束时间",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  "default-time": ["00:00:00", "23:59:59"],
                                },
                                on: { change: _vm.handleAuditTimeChange },
                                model: {
                                  value: _vm.auditTimeRange,
                                  callback: function ($$v) {
                                    _vm.auditTimeRange = $$v
                                  },
                                  expression: "auditTimeRange",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isMinAdmin
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "提交人：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth remote-user-select",
                                  attrs: {
                                    placeholder: "请输入提交人",
                                    clearable: "",
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                    "remote-method": _vm.handleCreatorSearch,
                                    loading: _vm.creatorLoading,
                                  },
                                  on: {
                                    focus: _vm.handleCreatorFocus,
                                    change: _vm.search,
                                  },
                                  model: {
                                    value: _vm.pageFrom.creatorId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageFrom, "creatorId", $$v)
                                    },
                                    expression: "pageFrom.creatorId",
                                  },
                                },
                                _vm._l(_vm.creatorOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.realName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isMinAdmin
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "审核人：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth remote-user-select",
                                  attrs: {
                                    placeholder: "请输入审核人",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  on: { change: _vm.search },
                                  model: {
                                    value: _vm.pageFrom.auditorId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageFrom, "auditorId", $$v)
                                    },
                                    expression: "pageFrom.auditorId",
                                  },
                                },
                                _vm._l(_vm.auditorOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.realName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发放公司：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请选择发放公司",
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.companyId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "companyId", $$v)
                                },
                                expression: "pageFrom.companyId",
                              },
                            },
                            _vm._l(_vm.companyList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.miniProgramCustomer
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "发卡小程序：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "请选择小程序",
                                    clearable: "",
                                    filterable: "",
                                  },
                                  on: { change: _vm.search },
                                  model: {
                                    value: _vm.pageFrom.appId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageFrom, "appId", $$v)
                                    },
                                    expression: "pageFrom.appId",
                                  },
                                },
                                _vm._l(_vm.miniappList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.appName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户手机号：", prop: "phone" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入客户手机号",
                              maxlength: "11",
                              clearable: "",
                            },
                            on: {
                              input: _vm.handlePhoneInput,
                              change: _vm.search,
                            },
                            model: {
                              value: _vm.pageFrom.phone,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.pageFrom,
                                  "phone",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "pageFrom.phone",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isMinAdmin
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "创建时间：" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetimerange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始时间",
                                  "end-placeholder": "结束时间",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  "default-time": ["00:00:00", "23:59:59"],
                                },
                                on: { change: _vm.search },
                                model: {
                                  value: _vm.pageFrom.time,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pageFrom, "time", $$v)
                                  },
                                  expression: "pageFrom.time",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.resetSearch },
                },
                [_vm._v("重置")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.search } },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:customer:integral:log:export"],
                      expression: "['admin:customer:integral:log:export']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.exportRecord },
                },
                [_vm._v("导出操作记录")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:customer:integral:log:export-detail"],
                      expression:
                        "['admin:customer:integral:log:export-detail']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.exportRecordDetail },
                },
                [_vm._v("导出操作明细")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:download:task:list"],
                      expression: "['admin:download:task:list']",
                    },
                  ],
                  attrs: { type: "warning" },
                  on: { click: _vm.openExportTaskDialog },
                },
                [_vm._v("导出任务")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:customer:integral:migration:upload"],
                      expression:
                        "['admin:customer:integral:migration:upload']",
                    },
                  ],
                  attrs: { type: "success" },
                  on: { click: _vm.openDataMigration },
                },
                [_vm._v("数据迁移")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:recharge-audit-config:get"],
                      expression: "['admin:recharge-audit-config:get']",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.openAuditConfig },
                },
                [_vm._v("审核配置")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                "row-key": "id",
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "projectNumber",
                  label: "项目编号",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "applicationNumber",
                  label: "申请编号",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "companyId",
                  label: "发放公司",
                  "min-width": "80",
                  formatter: _vm.formatCompanyName,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "salesPrice",
                  label: "销售总价",
                  "min-width": "80",
                  formatter: _vm.formatYuanColumn,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerEmpType",
                  label: "发放方式",
                  "min-width": "80",
                  formatter: _vm.customerEmpType,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "customerName",
                  label: "发放客户",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appName",
                  label: "发放小程序",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sendTypeName",
                  label: "发卡类型",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _vm.isMinAdmin
                ? _c("el-table-column", {
                    attrs: {
                      prop: "creatorId",
                      label: "提交人",
                      "min-width": "100",
                      formatter: _vm.formatAdminName,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "integral",
                  label: "面额",
                  "min-width": "80",
                  formatter: _vm.formatYuanColumn,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "integralTotal",
                  label: "涉及总面额",
                  "min-width": "80",
                  formatter: _vm.formatYuanColumn,
                },
              }),
              _vm._v(" "),
              !_vm.miniProgramCustomer || _vm.miniProgramCustomerId == 58
                ? _c("el-table-column", {
                    attrs: {
                      prop: "remainingIntegral",
                      label: "剩余总面额",
                      "min-width": "80",
                      formatter: _vm.formatYuanColumn,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empNum",
                  label: "关联员工数量",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              !_vm.miniProgramCustomer
                ? _c("el-table-column", {
                    attrs: {
                      prop: "couponPackageName",
                      label: "优惠券包",
                      "min-width": "80",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "record-status-text",
                            class: _vm.getGrantStatusTextClass(
                              scope.row.status
                            ),
                          },
                          [_vm._v(_vm._s(_vm.status(scope.row)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.isMinAdmin
                ? _c("el-table-column", {
                    attrs: {
                      prop: "auditStatus",
                      label: "审核状态",
                      "min-width": "80",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "record-status-text",
                                  class: _vm.getAuditStatusTextClass(
                                    scope.row.auditStatus
                                  ),
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.formatAuditStatus(scope.row))
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1753643309
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isMinAdmin
                ? _c("el-table-column", {
                    attrs: {
                      prop: "rejectReason",
                      label: "驳回原因",
                      "min-width": "120",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isMinAdmin
                ? _c("el-table-column", {
                    attrs: {
                      prop: "remark",
                      label: "内部备注",
                      "min-width": "100",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "innerRemark",
                  label: "备注",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fuCardName",
                  label: "发放福卡",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "exeTime",
                  label: "发放时间",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _vm.isMinAdmin
                ? _c("el-table-column", {
                    attrs: {
                      prop: "auditorId",
                      label: "审核人",
                      "min-width": "100",
                      formatter: _vm.formatAdminName,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isMinAdmin
                ? _c("el-table-column", {
                    attrs: {
                      prop: "auditTime",
                      label: "审核时间",
                      "min-width": "120",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "250",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customer:integral:log:info"],
                                expression:
                                  "['admin:customer:integral:log:info']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.detail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看明细")]
                        ),
                        _vm._v(" "),
                        scope.row.auditStatus === 0
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:customer:integral:log:audit",
                                    ],
                                    expression:
                                      "['admin:customer:integral:log:audit']",
                                  },
                                ],
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openIntegralAudit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              审核\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.auditStatus === 2 &&
                        scope.row.currentUserId === scope.row.creatorId
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:customer:integral:log:save"],
                                    expression:
                                      "['admin:customer:integral:log:save']",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  loading:
                                    _vm.resubmitLoadingId === scope.row.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.resubmit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              重新提交\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:customer:integral:edit"],
                                    expression:
                                      "['admin:customer:integral:edit']",
                                  },
                                ],
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editProjectInfo(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 1
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:customer:integral:edit:fuka",
                                    ],
                                    expression:
                                      "['admin:customer:integral:edit:fuka']",
                                  },
                                ],
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editProjectCardInfo(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑福卡信息")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.fileUrl
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadFile(scope.row.fileUrl)
                                  },
                                },
                              },
                              [_vm._v("下载发放文件")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.auditStatus === 2 &&
                        scope.row.currentUserId === scope.row.creatorId
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:customer:integral:log:delete",
                                    ],
                                    expression:
                                      "['admin:customer:integral:log:delete']",
                                  },
                                ],
                                staticStyle: { color: "#F56C6C" },
                                attrs: {
                                  type: "text",
                                  size: "small",
                                  loading: _vm.deleteLoadingId === scope.row.id,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteIntegralLogBatch(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              删除\n            ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [15, 30, 45, 60],
                  "page-size": _vm.pageFrom.limit,
                  "current-page": _vm.pageFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("DetailVue", {
            ref: "DetailVueRef",
            attrs: {
              companyList: _vm.companyList,
              adminUserOptions: _vm.adminUserOptions,
            },
            on: { refresh: _vm.onRefresh },
          }),
          _vm._v(" "),
          _c("ProjectEditVue", {
            ref: "ProjectEditVueRef",
            attrs: {
              sendTypeList: _vm.sendTypeList,
              companyList: _vm.companyList,
            },
            on: { refresh: _vm.onRefresh },
          }),
          _vm._v(" "),
          _c("ProjectCardEditVue", {
            ref: "ProjectCardEditVueRef",
            on: { refresh: _vm.onRefresh },
          }),
          _vm._v(" "),
          _c("DataMigrationDialog", {
            ref: "DataMigrationDialogRef",
            on: { refresh: _vm.onRefresh },
          }),
          _vm._v(" "),
          _c("AuditConfigDialog", { ref: "AuditConfigDialogRef" }),
          _vm._v(" "),
          _c("IntegralAuditDialog", {
            ref: "IntegralAuditDialogRef",
            on: { refresh: _vm.onRefresh },
          }),
          _vm._v(" "),
          _c("AddGrantVue", {
            ref: "AddGrantVueRef",
            attrs: { companies: _vm.companyList },
            on: { refresh: _vm.onRefresh },
          }),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.isExporting,
                title: _vm.exportDialogTitle,
                "show-close": true,
                "close-on-click-modal": true,
                "before-close": _vm.handleExportDialogClose,
                "custom-class": "export-dialog",
                width: "500px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isExporting = $event
                },
              },
            },
            [
              _c("div", { staticClass: "export-dialog-content" }, [
                _c("i", { staticClass: "el-icon-download export-icon" }),
                _vm._v(" "),
                _c("h3", { staticClass: "export-title" }, [
                  _vm._v(_vm._s(_vm.exportProgressText)),
                ]),
                _vm._v(" "),
                _vm.exportConditionText
                  ? _c("div", { staticClass: "export-condition" }, [
                      _c("div", { staticClass: "condition-label" }, [
                        _vm._v("本次导出条件："),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "condition-content" }, [
                        _vm._v(_vm._s(_vm.exportConditionText)),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "progress-container" },
                  [
                    _vm.exportProgress < 100
                      ? _c("el-progress", {
                          attrs: {
                            percentage: _vm.exportProgress,
                            "stroke-width": 20,
                            color: _vm.customColors,
                            "text-inside": true,
                          },
                        })
                      : _c("el-progress", {
                          attrs: {
                            percentage: 100,
                            "stroke-width": 20,
                            color: "#67C23A",
                            status: "success",
                            "text-inside": true,
                          },
                        }),
                    _vm._v(" "),
                    _c("div", { staticClass: "progress-info" }, [
                      _c("span", { staticClass: "status-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.exportProgress < 100
                              ? "导出处理中..."
                              : "导出完成！"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "progress-text" }, [
                        _vm._v(_vm._s(_vm.exportProgress) + "%"),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.exportProgress < 100
                  ? _c("div", { staticClass: "export-tip" }, [
                      _c("i", { staticClass: "el-icon-info" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "关闭弹窗后可在「导出任务」中查看进度和下载文件"
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.exportTaskDialogVisible,
                title: "导出任务列表",
                width: "800px",
                "close-on-click-modal": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.exportTaskDialogVisible = $event
                },
              },
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.exportTaskLoading,
                      expression: "exportTaskLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.exportTaskList, size: "mini", border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "taskTypeName",
                      label: "任务类型",
                      "min-width": "120",
                      formatter: function (row) {
                        return _vm.formatTaskTypeName(row.taskType)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "statusName",
                      label: "状态",
                      "min-width": "80",
                      formatter: function (row) {
                        return _vm.formatStatusName(row.status)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getStatusTagType(scope.row.status),
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formatStatusName(scope.row.status)
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "progress",
                      label: "进度",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-progress", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                percentage: scope.row.progress || 0,
                                status: _vm.getProgressStatus(scope.row.status),
                                "show-text": true,
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fileName",
                      label: "文件名",
                      "min-width": "150",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "创建时间",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "100",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status === "COMPLETED"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadExportTaskFile(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                下载\n              "
                                    ),
                                  ]
                                )
                              : scope.row.status === "FAILED"
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "#F56C6C" } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.errorMessage || "失败"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticStyle: { color: "#909399" } },
                                  [
                                    _vm._v(
                                      "\n                -\n              "
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "block",
                  staticStyle: { "margin-top": "15px", "text-align": "right" },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "page-sizes": [10, 20, 50],
                      "page-size": _vm.exportTaskPageFrom.limit,
                      "current-page": _vm.exportTaskPageFrom.page,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.exportTaskListTotal,
                    },
                    on: {
                      "size-change": _vm.exportTaskHandleSizeChange,
                      "current-change": _vm.exportTaskHandlePageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }